import React, { useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

const DashboardLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isDesktop = useMediaQuery("(min-width: 1024px)");

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <Box display="flex" minHeight="100vh">
      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        isDesktop={isDesktop}
      />
      <Box flexGrow={1} display="flex" flexDirection="column">
        <Topbar onMenuClick={toggleSidebar} />
        <Box p={3} flexGrow={1}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
